export const LEAVE_CASE_OPEN_QUEUE = 'LEAVE_CASE_OPEN_QUEUE';
export const MAX_SNACKBARS = 5;
